import React, {useRef} from 'react'
import Section1 from '../pages/fodc/Section1'
import Section2 from '../pages/fodc/Section2'
import Section3 from '../pages/fodc/Section3'
import Section4 from '../pages/fodc/Section4'
import Section5 from '../pages/fodc/Section5'

const Fodc = () => {
    const sectionRef = useRef(null);

    const handleScroll = () => {
        sectionRef.current?.scrollIntoView({ behavior: 'smooth' });
    };
  return (
    <div className='fodc-view' style={{overflow:'hidden'}}>
        <Section1 onScroll={handleScroll} />
        <Section2 />
        <Section3 />
        <Section4 refProp={sectionRef} />
        <Section5 />
        <p className='text-center fodc-footer mb-0' style={{padding:'25px 0'}}>© 2025 Voosh food technologies, All Rights Reserved</p>
    </div>
  )
}

export default Fodc